import {
	Button,
	Collapse,
	Space,
	Input,
	Form,
	Row,
	Col,
	Typography,
} from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { TextInput } from "@components/atoms";
import useVouchersFilters from "./useVoucherFilters";

const { Panel } = Collapse;
const { Text } = Typography;

type VouchersFiltersProps = {
	submitFilters: ({
		voucher,
		first,
		page,
	}: {
		first: number;
		page: number;
		voucher: any; // TODO: fix type
	}) => void;
	total: number;
};

const VouchersFilters = ({ submitFilters, total }: VouchersFiltersProps) => {
	const {
		expandIcon,
		filters,
		onApplyFilters,
		form,
		initialValues,
		resetFields,
		isFilterApplied,
		tiers,
	} = useVouchersFilters({ submitFilters });
	return (
		<div>
			<div
				style={{
					background: "#fff",
					marginBottom: "20px",
					borderRadius: "10px",
					padding: "15px 0px",
				}}
			>
				<Collapse
					collapsible="icon"
					expandIconPosition="end"
					bordered={false}
					expandIcon={expandIcon}
					style={{
						background: "#fff",
					}}
				>
					<Panel
						header={
							<div style={{ display: "flex", justifyContent: "space-between" }}>
								<Form form={form} name="searchForm">
									<Form.Item name="search">
										<Input
											prefix={<SearchOutlined />}
											placeholder="Search"
											onPressEnter={(e: React.FormEvent<HTMLInputElement>) => {
												if (e.currentTarget.value.length > 0) {
													form.submit();
												}
											}}
										/>
									</Form.Item>
								</Form>
							</div>
						}
						key=""
					>
						<Form.Provider onFormFinish={onApplyFilters}>
							{/* this is nasty but the only way i managed to find to include the 2 forms in the provider */}
							<div style={{ display: "none" }}>
								<Form form={form} name="searchForm">
									<Form.Item name="search">
										<Input />
									</Form.Item>
								</Form>
							</div>
							<Form
								layout="vertical"
								initialValues={initialValues}
								form={form}
								name="vouchersFilters"
							>
								<Row gutter={20}>
									{filters(tiers).map((filter) => (
										<Col key={filter.name} span={6}>
											<TextInput {...filter} />
										</Col>
									))}
								</Row>
								<Row justify="end">
									<Col>
										<Space align="center">
											<Button
												style={{ background: "#C4D9F2", color: "#1F65B6" }}
												type="primary"
												onClick={resetFields}
											>
												Clear Filters x
											</Button>
											<Button type="primary" htmlType="submit">
												Apply Filters
											</Button>
										</Space>
									</Col>
								</Row>
							</Form>
						</Form.Provider>
					</Panel>
				</Collapse>
				{isFilterApplied && (
					<>
						<Text strong style={{ paddingLeft: "16px" }}>
							Result:{" "}
						</Text>
						<Text>{total}</Text>
					</>
				)}
			</div>
		</div>
	);
};

export default VouchersFilters;
